import s from"./_Hash.js";import t from"./_ListCache.js";import a from"./_Map.js";function i(){this.size=0,this.__data__={hash:new s,map:new(a||t),string:new s}}export{i as default};
//# sourceMappingURL=_mapCacheClear.js.map
